// CardVersionNotice.js
// The banner a View card shows ABOVE its result when the version it runs is not
// the version its result or its filters came from: the Function was published
// while the View was open, or the result on screen was produced by an earlier
// version. It informs and never blocks — the card keeps its result and stays
// runnable. The list of what changed is collapsed by default because a card
// can be as small as a stat tile.

import React, { useState } from 'react';
import { Alert, Box, Button, Collapse } from '@mui/material';
import { countNoun } from '../../../utils/pluralise';

function CardVersionNotice({
  // { message: string, changes: string[] }
  notice,
  onDismiss,
}) {
  const [changesShown, setChangesShown] = useState(false);
  const changeCount = notice.changes.length;

  return (
    <Alert severity={changeCount > 0 ? 'warning' : 'info'} onClose={onDismiss} sx={{ mb: 1 }}>
      {notice.message}
      {changeCount > 0 && (
        <>
          <Button
            size="small"
            color="inherit"
            onClick={() => setChangesShown((shown) => !shown)}
            sx={{ display: 'block', mt: 0.5, p: 0, minWidth: 0, textTransform: 'none', textDecoration: 'underline' }}
          >
            {changesShown ? 'Hide changes' : `Show ${countNoun(changeCount, 'change')}`}
          </Button>
          <Collapse in={changesShown} unmountOnExit>
            <Box component="ul" sx={{ mt: 0.5, mb: 0, pl: 2.5 }}>
              {notice.changes.map((change, index) => (
                // Two sources may share a name, so two changes can read alike.
                <li key={`${index}-${change}`}>{change}</li>
              ))}
            </Box>
          </Collapse>
        </>
      )}
    </Alert>
  );
}

export default CardVersionNotice;
